export { default } from './SupersearchResultHeader';
